import { Toaster as Sonner, type ToasterProps } from 'sonner';

/**
 * The surface every `toast()` in the app renders into.
 *
 * There was no Toaster mounted anywhere, so all 22 files calling toast() were
 * writing to nothing: success confirmations, submission failures and the spam
 * notice were all silently discarded. That is why several forms grew their own
 * inline banners for messages a toast was supposed to carry.
 *
 * The generated wrapper read the theme from next-themes, which this app has no
 * provider for, so it always resolved to the default anyway.
 */
export function Toaster(props: ToasterProps) {
  return (
    <Sonner
      className="toaster group"
      position="top-center"
      richColors
      closeButton
      {...props}
    />
  );
}
